import React from 'react';
import { SecondarySidebarButton } from './styles';
import { useSlideSequenceMutation } from '@mutations/scenarios';
import { useUser } from '@context/user';
import { DEFAULT_SEQUENCE } from '@constants';

export const ResetSlideSequenceButton = () => {
    const { scenarioId } = useUser();
    const slideSequenceMutation = useSlideSequenceMutation();

    const resetSlideSequence = async () => {
        slideSequenceMutation.mutate({ sequence: DEFAULT_SEQUENCE, isDefault: true, scenarioId });
    };

    return (
        <SecondarySidebarButton onClick={resetSlideSequence}>
            Reset Slide Sequence
        </SecondarySidebarButton>
    );
};

export default ResetSlideSequenceButton;
